import type { IconNode } from '../types';

/**
 * @name bowl-chopsticks
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtMTMgMi0zIDExIiAvPgogIDxwYXRoIGQ9Im0yMiAyLTggMTEiIC8+CiAgPGVsbGlwc2UgY3g9IjEyIiBjeT0iMTIiIHJ4PSIxMCIgcnk9IjUiIC8+CiAgPHBhdGggZD0iTTIyIDEyYTEwIDEwIDAgMCAxLTIwIDAiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/bowl-chopsticks
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const bowlChopsticks: IconNode = [
  ['path', { d: 'm13 2-3 11', key: '1gcvd1' }],
  ['path', { d: 'm22 2-8 11', key: '1vhxzy' }],
  ['ellipse', { cx: '12', cy: '12', rx: '10', ry: '5', key: '13gdcd' }],
  ['path', { d: 'M22 12a10 10 0 0 1-20 0', key: '8qnpff' }],
];

export default bowlChopsticks;
